export default __webpack_public_path__ + "static/media/330.88a28a26.jpg";